module.exports = __webpack_public_path__ + "media/KikiG.ac513f3b.mp3";